<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <div>
        <div class="field select first">
          <label>{{messages["qsim.sim.provider"]}}</label>
          <ValidationProvider :name='messages["qsim.sim.provider"]' rules="required" v-slot="{ errors }">
            <div class="select-box">
              <span class="icon arrow"></span>
              <span class="selected">{{selectedProvider}}</span>
              <select v-model="selectedProvider">
                <option value=""></option>
                <option value="Cosmote">Cosmote</option>
                <option value="Vodafone">Vodafone</option>
              </select>
            </div>
            <span class="field-validation-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <ValidationProvider :name='messages["qsim.sim.msisdn"]' :rules="{ required: true, regex: /^[6][9][0-9]{8}$/ }" v-slot="{ errors }">
          <div class="field">
            <label>{{messages["qsim.sim.msisdn"]}}</label>
            <input class="text text-box single-line" type="text" v-model="portabilityNumber" maxlength="10">
            <span class="field-validation-error">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div class="formBlock">
        <div class="blockTitle noMargin">{{messages["qsim.title"]}}</div>
        <p class="blockSubtitle">{{messages["qsim.subtitle"]}}</p>
        <div class="packs-table">
          <!-- ko foreach: Products -->
          <div class="item" v-for="product in prepaidProducts" :key="product.imageUrl">
            <table>
              <tbody>
              <tr>
                <td>
                  <div :id="product.id" class="checkbox productCheckbox" @click="selectProduct($event)">
                                    <span class="input icon">
                                        <input type="checkbox">
                                    </span>
                  </div>
                </td>
                <td class="img"><img :src="product.imageUrl"></td>
              </tr>
              </tbody>
            </table>
          </div>
          <!-- /ko -->
        </div>
      </div>
      <div v-show="productSelected">
        <div class="formBlock" >
          <div class="blockTitle">{{messages["qsim.personal.title"]}}</div>
          <ValidationProvider :name='messages["qsim.personal.name"]' rules="required|alpha_spaces" v-slot="{ errors }">
            <div class="field first" :class=" {error: errors[0]} ">
              <label for="OrderUserName">{{messages["qsim.personal.name"]}}</label>
              <input class="text" id="OrderUserName" name="OrderUserName" type="text" v-model="form.firstName">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.personal.surname"]' rules="required|alpha_spaces" v-slot="{ errors }">
            <div class="field" :class=" {error: errors[0]} ">
              <label for="OrderUserSurname">{{messages["qsim.personal.surname"]}}</label>
              <input class="text" id="OrderUserSurname" name="OrderUserSurname" type="text" v-model="form.surname">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.personal.fathername"]' rules="required|alpha_spaces" v-slot="{ errors }">
            <div class="field tFirst" :class=" {error: errors[0]} ">
              <label for="OrderUserFatherName">{{messages["qsim.personal.fathername"]}}</label>
              <input class="text" id="OrderUserFatherName" name="OrderUserFatherName" type="text" v-model="form.fathername">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.personal.birthplace"]' rules="required" v-slot="{ errors }">
            <div class="field dFirst" :class=" {error: errors[0]} ">
              <label for="OrderUserBirthPlace">{{messages["qsim.personal.birthplace"]}}</label>
              <input class="text" data-val="true" data-val-required="" id="OrderUserBirthPlace" name="OrderUserBirthPlace" type="text" v-model="form.birthplace">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="field select inline tFirst">
            <label>{{messages["qsim.personal.birthdate"]}}</label>
            <div class="date-dropdowns birthDate spaceRow fieldWrap">
              <div class="select-box s first">
                <span class="icon arrow"></span>
                <span class="selected">{{form.birthDate.day}}</span>
                <select v-model="form.birthDate.day" @change="displayDateMessage">
                  <option v-for="day in 31" :key="day" class="dropdown_option" :value="day">{{day}}</option>
                </select>
                <input id="BirthDate_Day" name="BirthDate.Day" type="hidden" value="">
              </div>
              <div class="select-box m2">
                <span class="icon arrow"></span>
                <span class="selected">{{form.birthDate.month}}</span>
                <select v-model="form.birthDate.month" @change="displayDateMessage">
                  <option v-for="month in 12" :key="month" class="dropdown_option" :value="month<10 ? '0'+month : month">{{month}}</option>
                </select>
                <input id="BirthDate_Month" name="BirthDate.Month" type="hidden" value="">
              </div>
              <div class="select-box m">
                <span class="icon arrow"></span>
                <span class="selected">{{form.birthDate.year}}</span>
                <select v-model="form.birthDate.year" @change="displayDateMessage">
                  <option v-for="year in years" :key="year" class="dropdown_option" :value="year">{{year}}</option>
                </select>
                <input id="BirthDate_Year" name="BirthDate.Year" type="hidden" value="">
              </div>
              <input class="validate-hidden" data-val="true" data-val-date="Το πεδίο Birth Date πρέπει να είναι ημερομηνία" data-val-required="Παρακαλούμε συμπλήρωσε το πεδίο Birth Date" id="BirthDate" name="BirthDate" type="hidden" value="">
            </div>
            <ValidationProvider name="Birth Date" rules="dateRequired|validDate|minimumAge" v-slot="{ errors }">
              <input type="hidden" name="" v-model="form.birthDate">
              <span class="field-validation-error date-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="formBlock" >
          <div class="blockTitle">{{messages["qsim.contact.title"]}}</div>
          <ValidationProvider :name='messages["qsim.contact.email"]'
                              rules="required|email|required:true"
                              vid="email"
                              v-slot="{ errors }">
            <div class="field first"
                 :class=" {error: errors[0]} ">
              <label for="OrderUserEmail">{{messages["qsim.contact.email"]}}</label>
              <input class="text text-box single-line"
                     id="OrderUserEmail"
                     name="OrderUserEmail"
                     type="email"
                     autocomplete="none"
                      @paste.prevent
                     v-model="form.email">
              <span class="field-validation-error">
                <span>{{ errors[0] }}</span>
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.contact.confirmEmail"]'
                              rules="required|email|required:true|confirmed:email"
                              v-slot="{ errors }">
            <div class="field tFirst"
                 :class=" {error: errors[0]} ">
              <label for="confirmEmail">{{messages["qsim.contact.confirmEmail"]}}</label>
              <input class="text text-box single-line"
                     id="confirmEmail"
                     name="confirmEmail"
                     type="email"
                     autocomplete="none"
                     @paste.prevent
                     v-model="form.confirmEmail">
              <span class="field-validation-error">
                <span>{{ errors[0] }}</span>
              </span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.contact.address"]' rules="required" v-slot="{ errors }">
            <div class="field first" :class=" {error: errors[0]} ">
              <label for="OrderUserAddress">{{messages["qsim.contact.address"]}}</label>
              <input class="text text-box single-line" id="OrderUserAddress" name="OrderUserAddress" type="text" v-model="form.address">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.contact.addressNumber"]' :rules="{ required: true, regex: /^[0-9]*$/ }" v-slot="{ errors }">
            <div class="field tFirst" :class=" {error: errors[0]} ">
              <label for="OrderUserAddressNumber">{{messages["qsim.contact.addressNumber"]}}</label>
              <input class="text text-box single-line" id="OrderUserAddressNumber" name="OrderUserAddressNumber" type="text" maxlength="3" v-model="form.addressNumber">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.contact.postal"]' rules="required|digits:5" v-slot="{ errors }">
            <div class="field first" :class=" {error: errors[0]} ">
              <label for="OrderUserZipCode">{{messages["qsim.contact.postal"]}}</label>
              <input class="text text-box single-line" id="OrderUserZipCode" name="OrderUserZipCode" type="text" v-model="form.postalCode">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <ValidationProvider :name='messages["qsim.contact.city"]' rules="required" v-slot="{ errors }">
            <div class="field tFirst" :class=" {error: errors[0]} ">
              <label for="OrderUserCity">{{messages["qsim.contact.city"]}}</label>
              <input class="text text-box single-line" id="OrderUserCity" name="OrderUserCity" type="text" v-model="form.city">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="field select first">
            <label for="OrderUserRegionID">{{messages["qsim.contact.county"]}}</label>
            <ValidationProvider :name='messages["qsim.contact.county"]' rules="required" v-slot="{ errors }">
              <div class="select-box" :class=" {error: errors[0]} ">
                <span class="icon arrow"></span>
                <span class="selected">{{counties[selectedCounty-1]}}</span>
                <select v-model="selectedCounty">
                  <option class="dropdown_option" value="">-</option>
                  <option v-for="(county, index) in counties" :key="index" class="dropdown_option" :value="index+1">{{county}}</option>
                </select>
                <span class="field-validation-error">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <ValidationProvider :name='messages["qsim.contact.msisdn"]' :rules="{ required: true, regex: /^[6][9][0-9]{8}$/ }" v-slot="{ errors }">
            <div class="field tFirst" :class=" {error: errors[0]} ">
              <label for="OrderUserContactNumber">{{messages["qsim.contact.msisdn"]}}</label>
              <input class="text text-box single-line" id="OrderUserContactNumber" name="OrderUserContactNumber" type="tel" maxlength="10" v-model="form.msisdn">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
        <div class="formBlock" >
          <div class="blockTitle">{{messages["qsim.documents.title"]}}</div>
          <div class="field select first">
            <label for="LegalDocumentType">{{messages["qsim.documents.doc"]}}</label>
            <ValidationProvider :name='messages["qsim.documents.doc"]' rules="required" v-slot="{ errors }">
              <div class="select-box" :class=" {error: errors[0]} ">
                <span class="icon arrow"></span>
                <span class="selected">{{identificationDocuments[selectedDocument-1]}}</span>
                <select v-model="selectedDocument">
                  <option class="dropdown_option" data-value="">- </option>
                  <option v-for="(document, index) in identificationDocuments" :key="index" class="dropdown_option" :value="index+1">{{document}}</option>
                </select>
              </div>
              <span class="field-validation-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <ValidationProvider :name='messages["qsim.documents.docno"]' rules="required" v-slot="{ errors }">
            <div class="field" :class=" {error: errors[0]} ">
              <label for="OrderUserIdentificationCode">{{messages["qsim.documents.docno"]}}</label>
              <input class="text text-box single-line" id="OrderUserIdentificationCode" name="OrderUserIdentificationCode" type="text" v-model="form.idCode">
              <span class="field-validation-error">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="checkbox full field noMargin">
                    <span class="input icon">
                    <input class="check-box" id="AcceptLegalTerms" name="AcceptLegalTerms" type="checkbox" value="true">
                    </span>
            <label v-html="messages['qsim.terms']"></label>
            <span class="field-validation-error" id="AcceptLegalTermsError" style="display: none;">{{messages["qsim.validation.terms"]}}</span>
          </div>
          <div class="checkbox full field  noMargin">
                    <span class="input icon">
                    <input class="check-box" id="AcceptNewsLetter" name="AcceptNewsLetter" type="checkbox" value="true">
                      <input name="AcceptNewsLetter" type="hidden" value="false">
                    </span>
            <label for="AcceptNewsLetter">{{messages["qsim.newsletter"]}}</label>
            <span class="field-validation-valid" data-valmsg-for="AcceptNewsLetter" data-valmsg-replace="true"></span>
          </div>
        </div>
        <div class="formBlock sel-prods" >
          <div class="blockTitle">{{messages["qsim.cart.title"]}}</div>
          <div>
            <table class="total">
              <tbody>
              <tr>
                <th>{{messages["qsim.cart.product"]}}</th>
                <th>{{messages["qsim.cart.cost"]}}</th>
                <th></th>
              </tr>
              <!-- ko foreach: SimCards-->
              <tr :key="product" :id="product.id">
                <td>{{product.title}}</td>
                <td>{{product.price}}</td>
                <!-- <td width="15%">
                    <a href="#" class="removeproduct" @click.prevent="handleProductRemoval">
                    <img src="/ext_files/prepaid/q/media/x.png">
                    </a>
                    <input type="hidden" name="" :value="product.id">
                </td> -->
              </tr>
              <!-- /ko -->
              </tbody>
            </table>
          </div>
        </div>
        <input :value='messages["qsim.button"]' class="button orderSubmit" type="submit" @click="handleSubmit(submitForm)">
        <span class="error">
                <span class="field-validation-error" v-html="errorMessage"></span>
                </span>
        <div id="captcha-box" v-show="captchaVersion=='v2'">
          <div id="captchaTest"></div>
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <p class="error"><span class="field-validation-error"></span></p>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { validate } from 'vee-validate';

export default {
  name: 'Portability',
  components: {
  },
  props: {
    messages: Object,
    identificationDocuments: Array,
    prepaidProducts: Array,
    counties: Array,
  },
  data: function () {
    return {
      locale: "",
      selectedDocument: "",
      selectedCounty: "",
      selectedProvider: "",
      portabilityNumber: "",
      form: {
        firstName: "",
        surname: "",
        fathername: "",
        birthplace: "",
        birthDate: {
          day: "",
          month: "",
          year: ""
        },
        email: "",
        confirmEmail:"",
        msisdn: "",
        address: "",
        addressNumber: "",
        postalCode: "",
        city: "",
        idCode: ""
      },
      captchaVersion: "v3",
      widgetId: "",
      errorMessage: "",
      dateFilled: false,
      productSelected: false,
      product: {}
    }
  },
  mounted: function () {
    formInputInit();
  },
  computed: {
    showForm(){
      return this.totalQuantity != 0;
    },
    years(){
      return Array.from({length: 2004 - 1919}, (value, index) => 2004 - index);
    }
  },
  methods: {
    selectProduct(event) {
      document.getElementsByClassName("productCheckbox").forEach(element => {
        element.classList.remove("selected");
      })
      var simID;
      if (event.target.className == ".productCheckbox") {
        simID = event.target.id;
      } else {
        simID = event.target.closest(".productCheckbox").id;
      }

      var self = this;
      this.prepaidProducts.forEach(function (product) {
        if (product.id == simID) self.product = product;
      });
      this.productSelected = true;
      console.log(event.target.closest(".productCheckbox").classList)
    },
    submitForm() {
      var self = this;
      if (this.validateTerms()){
        if (this.validateCaptcha()) {
          document.getElementsByClassName("loading")[0].classList.add("enable");
          var payload = this.prepareRequest();
          var v3Key = document.getElementsByTagName("body")[0].dataset.captchav3;
          grecaptcha.execute(v3Key, {action: 'qsimorder'}).then(function(token) {
            payload.captchaToken = token;
            if (self.captchaVersion == "v2") {
              payload.captchaToken = grecaptcha.getResponse(self.widgetId);
            }
            payload.captchaVersion = self.captchaVersion;
            self.axios.post(`/apiv2/prepaidcustomer/submitPrepaidOrder/`, payload).then((response) => {
              if (response.data.errorLevel == 0) {
                handleDataLayer.init();
                handleDataLayer.pushSimpleDataLayer("Sim Order");
                self.$store.commit('setEmail', self.form.email);
                self.$store.commit('setProduct', self.product);
                self.$emit('orderComplete', {
                  product: self.product
                })
              } else if (response.data.errorCode == 7012) {
                if (self.captchaVersion != "v2") {
                  var v2Key = document.getElementsByTagName("body")[0].dataset.captchav2;
                  grecaptcha.ready(() => {
                    self.widgetId = grecaptcha.render('captchaTest', {
                      'sitekey' : v2Key,
                      'theme' : 'light'
                    });
                  });
                }
                self.captchaVersion = "v2";
                document.getElementsByClassName("loading")[0].classList.remove("enable");
              } else {
                console.log(`Error: ${response.data.errorMessage}`);
                document.getElementsByClassName("loading")[0].classList.remove("enable");
                self.errorMessage = response.data.errorMessage;
              }
              document.getElementsByClassName("loading")[0].classList.remove("enable");
            }).catch((error) => {
              console.log(error);
              var locale = document.getElementsByTagName("body")[0].dataset.locale;
              if (locale == "en_US") {
                self.errorMessage = "Something went wrong, please try again.";
              } else {
                self.errorMessage = "Κάτι πήγε στραβά, παρακαλούμε δοκίμασε ξανά.";
              }
              document.getElementsByClassName("loading")[0].classList.remove("enable");
            });
          })
        }
      }
    },
    validateTerms(){
      if (document.getElementById("AcceptLegalTerms").checked) {
        document.getElementById("AcceptLegalTermsError").style.display = "none";
      } else {
        document.getElementById("AcceptLegalTermsError").style.display = "";
      }
      return document.getElementById("AcceptLegalTerms").checked;
    },

    validateCaptcha() {
      if (this.captchaVersion == "v2" && grecaptcha.getResponse(this.widgetId).length == 0) {
        $('body').data('locale') == "el_GR" ?
            $('#captcha-box > div > div > p > span').html('To captcha πρέπει να συμπληρωθεί.') :
            $('#captcha-box > div > div > p > span').html('Please fill in the captcha.');
        $("#captcha-box > div > div > p > span").show();
      } else {
        $('#captcha-box > div > div > p > span').html('')
        $("#captcha-box > div > div > p > span").hide();
      }
      return this.captchaVersion == "v3" || grecaptcha.getResponse(this.widgetId).length != 0;
    },
    prepareRequest(){
      //prepare request
      var request = {};
      request.caller = {};

      //Set caller
      //Replace values
      request.caller.callingSystem = "WINDweb";
      request.caller.salesCode = "";
      request.caller.username = "username";
      request.caller.locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";
      request.caller.channel = "Q";
      request.caller.data = "";

      request.orderType = "qsimorder"

      request.products = [];
      var prdct = {};
      console.log(this.product);
      prdct.productId = this.product.id;
      prdct.productName = this.product.title;
      prdct.productType = this.product.productDescription;
      prdct.portability = true;
      prdct.oldMsisdn = this.portabilityNumber;
      prdct.provider = this.selectedProvider
      request.products.push(prdct);

      request.name = this.form.firstName;
      request.surname = this.form.surname;
      request.fathersName = this.form.fathername;
      request.email = this.form.email;
      request.contactPhone = this.form.msisdn;
      request.deliveryRoadNumber = this.form.address+" "+this.form.addressNumber;
      request.city = this.form.city;
      request.zipCode = this.form.postalCode;
      request.county = this.counties[this.selectedCounty-1];
      request.birthPlace = this.form.birthplace;
      request.identificationDocument = this.identificationDocuments[this.selectedDocument-1];
      request.documentNumber = this.form.idCode;
      request.newsletter = document.getElementById("AcceptNewsLetter").checked;

      var dayOfBirth = this.form.birthDate.day;
      var monthOfBirth = this.form.birthDate.month;
      var yearOfBirth = this.form.birthDate.year;
      var birthDate = yearOfBirth+"-"+monthOfBirth+"-"+dayOfBirth;
      request.birthDate = birthDate;

      return request;
    },
    displayDateMessage() {
      validate(this.form.birthDate, 'dateRequired|validDate|minimumAge').then(result => {
        if (result.valid) {
          $('.date-error').hide();
        } else {
          if (!result.failedRules.validDate) {
            $('.date-error').html(result.errors[0]);
            $('.date-error').show();
          }
        }
      });
    }
  }
}
</script>

<style>

</style>
